import _ from 'underscore';
import React, { useContext } from 'react';

export const CouponContext = React.createContext({
  coupon: {},
  updateCoupon: _.noop,
  resetCouponStore: _.noop,
  isSignUp: false,
});
export const useCouponContext = () => useContext(CouponContext);
